import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthMe } from '../../hooks/queries';
import { canAccessMonitoring } from '../../utils/support-user';

interface AdminMonitoringRouteProps {
  children: React.ReactNode;
}

/** Blocks non-admin users from Monitoring / BC Permissions (ECU-2996). */
export function AdminMonitoringRoute({ children }: AdminMonitoringRouteProps) {
  const { data: response, isLoading } = useAuthMe();
  const persona = response?.data;

  if (canAccessMonitoring(persona)) {
    return <>{children}</>;
  }

  if (isLoading) {
    return (
      <div className="page-container">
        <div className="loading-state"><div className="spinner" />Loading…</div>
      </div>
    );
  }

  return <Navigate to="/analytics" replace />;
}
